import React from 'react';
import styles from './ProductInventoryView.module.css';
import masaLogo from '../Assets/MasaLogo.png';

const ProductInventoryView = () => {
  return (
    <main className={styles.dashboardView}>
      <header className={styles.header}>
        <img 
          loading="lazy" 
          src={masaLogo}
          className={styles.logo} 
          alt="Dashboard Logo" 
        />
        <h1 className={styles.dashboardTitle}>Product Inventory</h1>
      </header>
      <div className={styles.explanationText}>
        <p>
          Below is the comprehensive overview of the current products in the inventory. The table includes product details such as ID, name, count, and dimensions.
        </p>
      </div>
      <div className={styles.tableContainer}>
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Product Name</th>
              <th>Count</th>
              <th>Dimensions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>P001</td>
              <td>Foil</td>
              <td>100</td>
              <td>10x20cm</td>
            </tr>
            <tr>
              <td>P002</td>
              <td>Plastic</td>
              <td>200</td>
              <td>15x30cm</td>
            </tr>
            <tr>
              <td>P003</td>
              <td>Raw Materials</td>
              <td>300</td>
              <td>Varied</td>
            </tr>
          </tbody>
        </table>
      </div>
    </main>
  );
};

export default ProductInventoryView;
